var _path, _rect, _path2, _path3, _rect2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauloBastosLogoContractedHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C16 16.4183 12.4183 20 8 20C7.99813 20 7.99627 20 7.99441 20H8V16C10.2091 16 12 14.2091 12 12C12 9.79086 10.2091 8 8 8C5.79086 8 4 9.79086 4 12L0 12C0 7.58172 3.58172 4 8 4C12.4183 4 16 7.58172 16 12Z",
    fill: "#974BFA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 4,
    height: 12,
    fill: "#5800CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 20V16C5.79086 16 4 14.2091 4 12H0C3.09242e-06 16.4183 3.58172 20 8 20Z",
    fill: "#14002E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 12C32 7.58173 28.4183 4.00001 24 4V8C26.2091 8 28 9.79086 28 12C28 14.2091 26.2091 16 24 16C21.7909 16 20 14.2091 20 12H16C16 12 16 12 16 12C16 16.4183 19.5817 20 24 20C28.4183 20 32 16.4183 32 12Z",
    fill: "#5800CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    transform: "matrix(1 0 0 -1 16 12)",
    fill: "#974BFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11.989C16.0059 7.57899 19.5802 4.00522 23.9903 4H24V7.99999C24 7.99999 24 7.99999 24 7.99999C21.7908 7.99999 20 9.79085 20 12C20 12 20 12 20 12H16V11.989Z",
    fill: "#14002E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauloBastosLogoContractedHorizontal);
export default __webpack_public_path__ + "static/media/paulo-bastos-logo-contracted-horizontal.1714f7ec9b63218b3048efa1fe3c38bc.svg";
export { ForwardRef as ReactComponent };